import { css } from "@emotion/css";

import { rem, column, breakpoints } from "../../ui";
import {} from "../../types";
import { DrawerOpenTypes, DrawerPositionTypes } from "./types";

export const sidebar = ({
  open,
  width,
  position,
}: {
  width: number;
  open: DrawerOpenTypes;
  position: DrawerPositionTypes;
}) => css`
  ${column("lg")};
  align-items: center;
  padding: ${rem("lg")} ${rem("sm")};
  width: 90%;
  height: 100vh;
  max-width: ${rem(350)};
  background: #272727;
  z-index: 3;
  position: fixed;
  top: 0;
  ${position === "left" ? `left: 0;` : `right: 0;`}

  @media (max-width: ${breakpoints.lg - 1}px) {
    ${open === "close-full" ? "display: none;" : ""}
  }

  @media (min-width: ${breakpoints.lg}px) {
    width: ${rem(250)};
    min-width: ${rem(250)};

    &.animate__animated {
      position: fixed !important;
    }

    &.animate__fadeInLeft,
    .animate__fadeOutLeft {
      animation: none;
    }
  }
`;

export const layer = (open: DrawerOpenTypes) => {
  let opacity: number = 0;

  if (open === "opening") {
    opacity = 0;
  } else if (open === "open") {
    opacity = 1;
  } else if (open === "closing") {
    opacity = 1;
  } else if (open === "close") {
    opacity = 0;
  } else if (open === "close-full") {
    opacity = 0;
  }

  return css`
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: #22222269;
    z-index: 2;
    transition: opacity 600ms;

    @media (min-width: ${breakpoints.lg}px) {
      display: none;
    }

    opacity: ${opacity};
  `;
};
